export const aaDeletedItems = new Map();